function guestResendPasswordDialog () {
  return {
    restrict: 'E',
    templateUrl: '/guest/dialogs/guest-resend-password/guest-resend-password-dialog.html?$$REVISION$$'
  }
}

export { guestResendPasswordDialog }
